/* RepeatHourRenderer.js */

"use strict";
const InputNumberControl = require("@gluenetworks/input_number_control");
const StartEndComponent = require("../../grid_row_components/start_end_component/StartEndComponent");
const BaseScheduleRenderer = require("../../base/BaseScheduleRenderer");
const RendererUtils = require("../../base/RendererUtils");

class RepeatHourRenderer extends BaseScheduleRenderer {
    constructor(model) {
        super(model);
    }
    render(formContainerElem) {
        if (this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._startEndComp = new StartEndComponent(this._model);
                this._onMinuteComp = new InputNumberControl({value: 0, min: 0, max: 59});
                this._atParts = RendererUtils.groupGridRowElements(
                    formContainerElem,
                    "at",
                    "On Minute",
                    this._onMinuteComp
                );

                return Promise.all([
                    this._onMinuteComp.renderer.render(),
                    this._startEndComp.renderer.render(formContainerElem),
                ]);
            })
            .then(() => {
                this._setTheme(this._model.theme);
                this._registerListeners();
                this.setRendered(true);
            });
    }
    getParts() {
        return this._atParts.concat(this._startEndComp);
    }
    shutdown() {
        if (!this.isRendered()) {
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                return Promise.all([
                    super.shutdown(),
                    this._onMinuteComp.shutdown(),
                    this._startEndComp.shutdown(),
                ]);
            })
            .then(() => {
                this._onMinuteComp = undefined;
                this._startEndComp = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    _registerListeners() {
        super._registerListeners();
        this._onMinuteComp.on("UserValue", (this._onMinute = this._onMinute.bind(this)));
    }
    _unregisterListeners() {
        super._unregisterListeners();
        this._onMinuteComp.removeListener("UserValue", this._onMinute);
    }
    _onMinute() {
        this._model.setScheduleProp("minute", this._onMinuteComp.getValue(), true);
    }
    _setControlValuesFromModel() {
        this._onMinuteComp.setValue(this._model.getScheduleProp("minute"));
    }
}
module.exports = RepeatHourRenderer;
